import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { SvgIcon } from '@material-ui/core';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function overrideChip(theme) {
  var sm = theme.breakpoints.up('sm');
  theme.props.MuiChip = {
    size: 'small',
    deleteIcon: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(SvgIcon, {
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.239 12L17 8.239 15.761 7 12 10.761 8.239 7 7 8.239 10.761 12 7 15.761 8.239 17 12 13.239 15.761 17 17 15.761 13.239 12z",
          fill: "currentColor"
        })
      })
    })
  };
  theme.overrides.MuiChip = {
    root: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      color: undefined,
      height: undefined,
      borderRadius: 4,
      backgroundColor: ColorDynamic.Silver200,
      '&$disabled': {
        opacity: undefined,
        color: ColorDynamic.Dark100
      }
    }),
    sizeSmall: {
      height: undefined
    },
    labelSmall: {
      paddingLeft: 6,
      paddingRight: 6,
      [sm]: {
        paddingLeft: 4,
        paddingRight: 4
      }
    },
    clickable: {
      '&:hover, &:focus': {
        backgroundColor: undefined
      },
      '&:active': {
        boxShadow: undefined
      },
      '&:focus': {
        boxShadow: "0 0 0 2px ".concat(ColorDynamic.Dark30)
      },
      '&:active, &:hover': {
        backgroundColor: ColorDynamic.Silver400
      }
    },
    deletable: {
      '&:focus': {
        backgroundColor: undefined,
        boxShadow: "0 0 0 2px ".concat(ColorDynamic.Silver400)
      }
    },
    deleteIcon: {
      width: undefined,
      height: undefined,
      display: 'flex',
      transition: theme.transitions.create('background-color'),
      '&:active, &:hover, &:focus': {
        '& > svg': {
          backgroundColor: ColorDynamic.Silver400
        }
      },
      '& > svg': {
        borderRadius: '50%',
        color: ColorDynamic.Dark100,
        fontSize: '1em'
      }
    },
    deleteIconSmall: {
      width: undefined,
      height: undefined,
      padding: theme.spacing(0.5),
      marginLeft: theme.spacing(-0.5),
      marginRight: theme.spacing(0.25),
      [sm]: {
        marginRight: 0
      }
    },
    icon: {
      color: ColorDynamic.Dark100,
      fontSize: '1em',
      marginRight: undefined
    },
    iconSmall: {
      width: undefined,
      height: undefined,
      marginLeft: 8,
      marginRight: undefined,
      [sm]: {
        marginLeft: 4
      }
    }
  };
}